import type { FileValue } from '@elfsight/configurator-contracts';
import { getFilenameFromURL } from '@elfsight/widget-utils';

export const getLinkAriaLabel = (link: FileValue) => {
  const { url = '', extension = '', name = '', isUploadedByLink } = link ?? {};
  const derivedName =
    isUploadedByLink || name === url ? getFilenameFromURL(url) : name;
  const fullName = derivedName.includes(extension)
    ? derivedName
    : `${derivedName}.${extension}`;

  return `Download the ${fullName}`;
};
